import React from 'react';
import styled from 'styled-components';
import Tag from '../../Molecules/Tag';
const StyledContainer = styled.div `
  display: inline-flex;
  flex-wrap: wrap;
  padding-top: 0.416666667rem;
`;
const StyledTag = styled(Tag) `
  margin: 0 0.416666667rem 0.416666667rem 0;
`;
const StyledMoreLabel = styled.span `
  display: inline-flex;
  align-items: center;
  height: 1.833333333rem;
`;
const renderTags = (tags, maxNumOfTags, areTagsRemovable, onTagClick, onTagRemove) => {
    let tagsToRender = tags;
    let restOfTags = 0;
    if (tags.length > maxNumOfTags) {
        tagsToRender = tags.slice(0, maxNumOfTags);
        restOfTags = tags.length - maxNumOfTags;
    }
    return (React.createElement(React.Fragment, null,
        tagsToRender.map((tag) => (React.createElement(StyledTag, { key: tag.name, isRemovable: areTagsRemovable, label: tag.label, name: tag.name, onClick: onTagClick, onRemove: onTagRemove }))),
        restOfTags > 0 && React.createElement(StyledMoreLabel, null,
            "+",
            restOfTags,
            " more")));
};
const TagList = ({ areTagsRemovable = false, onTagClick = () => { }, onTagRemove = () => { }, tags = [], maxNumOfTags = 8, }) => (React.createElement(StyledContainer, null, renderTags(tags, maxNumOfTags, areTagsRemovable, onTagClick, onTagRemove)));
export default TagList;
